import axios from '../../../http';
import router from '../../../routes';

const state = {
  isEconomy7: false,
  tariffDetails: [],
  supplierTosUrl: '',
  supplierId: 0,
  tariffName: null,
  supplierName: null,
  payMethod: 'MonthlyDirectDebit'
};

const getters = {
  notDirectDebit: (state) => {
    const directDebits = ['MonthlyDirectDebit', 'QuaterlyDirectDebit'];

    return directDebits.indexOf(state.payMethod) < 0;
  }
};

const actions = {
  async get({ rootState, commit, dispatch }) {
    const { switchKey } = rootState.storage;
    const { switchType } = rootState.storage.quote;
    const fuelTypes = {
      gasToGas: 'Gas',
      electricityToElectricity: 'Electricity',
      dualDistinctToDualConsolidated: 'Gas & Electricity',
      dualConsolidatedToDualConsolidated: 'Gas & Electricity'
    };

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/info/switch-plan',
        data: { switchKey }
      });

      if (status == 200) {
        const switchPlanInfoDto = data.geniusSwitchPlanInfoDto.geniusSwitchPlanInfo.switchPlanInfoDto;

        if (switchType == 'gasToGas') {
          switchPlanInfoDto.gas.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.gas);
        } else if (switchType == 'electricityToElectricity') {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          commit('updateState', switchPlanInfoDto.electricity);
        } else {
          switchPlanInfoDto.electricity.fuelTitle = fuelTypes[switchType];
          switchPlanInfoDto.electricity.gasCost = switchPlanInfoDto.gas.cost;
          switchPlanInfoDto.electricity.gasSavings = switchPlanInfoDto.gas.savings;
          commit('updateState', switchPlanInfoDto.electricity);
        }
      }
    } catch (error) {
      router.push({ name: 'currentTariff' });
    }
  },
  async completeSwitch({ dispatch, rootState }) {
    const { switchKey } = rootState.storage;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/complete',
        data: { switchKey, switchCompleteOption: 'None' }
      });

      if (status == 200) {
        await dispatch('storage/save', {
          prop: 'switched',
          value: {
            referenceNumber: data.geniusSwitchedDto.referenceNumbers.g || data.geniusSwitchedDto.referenceNumbers.e,
            name: `${data.geniusSwitchedDto.title} ${data.geniusSwitchedDto.firstName} ${data.geniusSwitchedDto.lastName}`,
            supplierName: data.geniusSwitchedDto.supplier
          }
        }, { root: true });
        await dispatch('storage/save', {
          prop: 'uuid',
          value: data.geniusSwitchedDto.uuid
        }, { root: true });

        router.push({ name: 'switchComplete' });
      } else {
        throw 'switch';
      }
    } catch (error) {
      throw 'switch';
    }
  },
  async holdSwitch({ state, rootState, dispatch }) {
    const { payMethod: paymentMethod, tariffId, supplierName } = state
    const { switchKey } = rootState.storage;
    const { completionDate, switchId: customerId, switchType } = rootState.storage.quote;

    try {
      const { status, data } = await axios({
        method: 'POST',
        url: '/request/switch/pro/hold/switch',
        data: {
          switchKey,
          switchType,
          customerId,
          tariffId,
          paymentMethod,
          completionDate,
          isTou: false
        }
      });

      if (status == 200) {
        await dispatch('storage/save', {
          prop: 'switchHold',
          value: {
            referenceNumber: `${customerId}`,
            supplierName,
            completionDate
          }
        }, { root: true });

        router.push({ name: 'switchHold' });
      } else {
        throw 'switch';
      }
    } catch (error) {
      console.log(error);

      throw 'switch';
    }
  },
  async handleSwitch({ dispatch, rootState }) {
    const { completionDate } = rootState.storage.quote;
    const diff = daysDiff(completionDate);

    if (diff <= 1) {
      return dispatch('completeSwitch');
    }

    dispatch('holdSwitch');
  },
  async switched({ dispatch, rootState }, route) {
    const routes = ['quoteResults', 'tariffDetails', 'personalDetails'];
    const { quote } = rootState.storage;

    // don't check if not in routes
    if (routes.indexOf(route) < 0) return false;

    try {
      const { data } = await axios({
        method: 'POST',
        url: '/request/customer/whitelabel/switch/complete',
        data: { switchId: quote.switchId }
      });

      if (data) {
        await dispatch('storage/save', {
          prop: 'alreadySwitched',
          value: true
        }, { root: true });

        router.push({ name: 'switchComplete' });
      }

      return data;
    } catch (error) {
      return false;
    }
  }
};

const mutations = {
  updateState(state, value) {
    state = Object.assign(state, value);
  }
};

function daysDiff(date) {
  const oneDay = 1000 * 60 * 60 * 24;
  const diffInTime = new Date(date).getTime() - new Date().getTime();
  const diffInDays = Math.ceil(diffInTime / oneDay);

  return diffInDays;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
